/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountBalanceWalletOutlined,
    ApartmentOutlined,
    AssignmentTurnedInOutlined,
    BedroomParentOutlined,
    ChildCare,
    FlagOutlined,
    PersonAdd,
    SchemaOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {useEffect, useState} from "react";
import {ESTADOSHABITACIONES, FECHACHECKIN} from "../../../Modulo_Motor_Reservas/Constantes";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Habitaciones = ({...props}) => {
    const [fechaInicio, setFechaInicio] = useState(new Date())


    useEffect(() => {
        let fechaEscogida = props.props.getValues(FECHACHECKIN)
        setFechaInicio(fechaEscogida)


    }, [props.props.watch(FECHACHECKIN)]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop  dato={'img'} {...props} ancho={3} alto={2}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={ApartmentOutlined} nombre={'Sector'} dato={'torre'} {...props}
                                   opciones={['Sector 1', 'Sector 2']}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={SchemaOutlined} nombre={'Sub Sector'} dato={'piso'} {...props}
                                   opciones={[1, 2, 3]}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={BedroomParentOutlined} nombre={'Nombre'} dato={'numero'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Tipo'} dato={'tipo'} {...props}
                                   opciones={['Sencilla', 'Doble', 'Cama King', 'Triple', 'Apto']}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoDinero Icono={FlagOutlined} nombre={'Tarifa Habitacion'} dato={'tarifa'} {...props}

                    />
                </Grid>


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoDinero Icono={PersonAdd} nombre={'Tarifa Acompañante'} dato={'tarifaAcompanante'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoDinero Icono={ChildCare} nombre={'Tarifa Niño'} dato={'tarifaNinos'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountBalanceWalletOutlined} nombre={'Link'} dato={'link'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelect Icono={AssignmentTurnedInOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOSHABITACIONES}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Habitaciones